<template>
  <v-layout column>
    <h4 v-if="title">{{ title }}</h4>
      <v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-flex xs12>
              <v-select
                autocomplete
                :items="fonts"
                v-model="settings.family"
                label="font family"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                <span :style="selectedFontFamily">
                {{ data.item }}
                </span>
                </template>

                <template
                  slot="item"
                  slot-scope="data"
                >
                  <span :style="currentFontFamily(data.item)">
                    {{ data.item }}
                  </span>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12>
              <content-field
                type="number"
                label="font size (px)"
                :value="settings.size"
                @input="onSizeChange"
                :error="$v.settings.size"
              />
            </v-flex>
            <v-flex xs12>
              <e-color-picker
                label="font color"
                :value="settings.color"
                @colorChange="onColorChange('color', $event)"
              />
            </v-flex>
            <v-flex xs12 v-if="hasHoverColor">
              <e-color-picker
                label="hover color"
                :value="settings.hoverColor"
                @colorChange="onColorChange('hoverColor', $event)"
              />
            </v-flex>
          </v-flex>
        </v-layout>
      </v-layout>
  </v-layout>
</template>

<script>
import availableFonts from '@/utils/fonts'
import EColorPicker from '@/components/shared/EColorPicker'
import { pathOr, assoc, omit, identity } from 'ramda'
import { required, numeric, maxValue } from 'vuelidate/lib/validators'
import {
  basicTextValidate,
  linkTextValidate,
  generateDefaultLinkParams,
  generateDefaultTextFonts,
  getColorsParams
} from './../styleForms/utils'

export default {
  name: 'FontSettings',
  components: {
    EColorPicker
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    hasHoverColor: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      validator: this.hasHoverColor ? linkTextValidate : basicTextValidate,
      default: this.hasHoverColor ? generateDefaultLinkParams : generateDefaultTextFonts
    }
  },
  data () {
    return {
      fonts: availableFonts
    }
  },
  validations: {
    settings: {
      size: {
        required,
        numeric,
        maxLength: maxValue(60)
      }
    }
  },
  computed: {
    selectedFontFamily () {
      const fontFamilyValue = pathOr('Montserrat', ['family'], this.settings)
      return {
        fontFamily: `${fontFamilyValue},sans-serif`,
        color: '#000000'
      }
    }
  },
  methods: {
    updateSettings (newSettings) {
      this.$v.$touch()
      const removeColors = this.hasHoverColor
        ? identity
        : omit(['hoverColor'])
      this.$emit('update:settings', removeColors(newSettings))
    },
    onSizeChange (ev) {
      this.updateSettings({
        ...this.settings,
        size: Number(ev)
      })
    },
    onColorChange (key, color) {
      const newSettings = assoc(
        key,
        getColorsParams(color),
        this.settings
      )
      this.updateSettings(newSettings)
    },
    currentFontFamily (item) {
      return { fontFamily: `${item},sans-serif` || '' }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/FontSettings.vue